export default __webpack_public_path__ + "static/agentic-automate-4fdb9ce68b4bc3f55373024e3cd9a596.png";